export default __webpack_public_path__ + "static/media/iphones-2.777a665a.png";